export default __webpack_public_path__ + "static/media/guarantee-certificate.52b372da.svg";